export const getSeverity = (
  event?: string
):
  | "danger"
  | "success"
  | "info"
  | "warning"
  | "secondary"
  | "contrast"
  | null => {

  if (!event) return null;

  const value = event.trim().toLowerCase();

  // % based handling
  if (value.endsWith("%")) {
    const percentage = Number(value.replace("%", ""));

    if (!isNaN(percentage)) {
      if (percentage < 20) return "danger";
      if (percentage < 70) return "warning";
      return "success";
    }
  }

  // 🔤 Text-based handling
  const severityMap: Record<
    string,
    "danger" | "success" | "info" | "warning" | "secondary" | "contrast"
  > = {
    "undesirable braking": "warning",
    "over speeding": "warning",
    "warning": "warning",
    "healthy": "success",
    "critical": "danger",
    "mode degradation": "secondary",
    "worst": "danger",
    "good": "success",
    "out of sync": "danger",
    "in sync": "success",
    "event": "danger",
    "bad": "danger",
    "brake failure": "danger",
    "recovery": "success",
    "normal": "success",
    "slip/slide detected": "contrast",
    "executive sw changed": "warning",
    "reset detected": "danger",
    "tag missing": "info",
    "configurable checksum changed": "info",
    "kavach parameter changed": "contrast",
    "version changed": "success",
    "radio_health_detected": "warning"
  };

  return severityMap[value] ?? "secondary";
};


export const getFontFamily = () => {
  return getComputedStyle(document.documentElement).getPropertyValue('--font-primary').trim();
};

export const formatDateInDDMMYYYY = (date: Date | null): string => {
  if (!date) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export const ddmmyyyyToMmddyyyy = (value: string): string => {
  const [dd, mm, yyyy] = value.split('/').map(Number);

  if (!dd || !mm || !yyyy) {
    throw new Error("Invalid date format");
  }

  return `${mm}/${dd}/${yyyy}`;
};

export const getTooltip = (value: string) => {
  const map: Record<string, string> = {
    'Executive SW Changed': 'Software version or executable changed',
    'Reset Detected': 'System reset detected',
    'Invalid': 'Checksum or data invalid'
  };

  return map[value] || '';
};

export const shortForm = (value: string) => {
  return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .join('');
}



